/**
 * Usercentrics consent utils
 */

// technology IDs: https://docs.usercentrics.com/#/smart-data-protector?id=currently-supported-technologies
export const techID = {
  googleMaps: 'S1pcEj_jZX',
  youtube: 'BJz7qNsdj-7',
  linkedIn: 'Hkx754i_iWm',
  facebookSocial: 'XYQZBUojc'
}

export function consentIsGiven(id: string): boolean {
  // @ts-ignore
  return !window.UC_UI || !window.uc || window.UC_UI.getServicesBaseInfo().find(data => (data.id === id)).consent.status;
}

export function showConsentOverlay() {
  // @ts-ignore
  if (window.UC_UI) {
    // @ts-ignore
    window.UC_UI.showFirstLayer();
  }
}
